import React from 'react';

const step3 = (props) => {
  const { randomQuestions, paperInfo } = props;


  const renderQuestion = (questionObj) => {
    if (paperInfo.questionType === "MCQ") {
      return (
        <div className='p-4 mb-4 border rounded-lg shadow-sm'>
          <h3 className="font-medium mb-3">{questionObj.question} ({questionObj.marks} marks)</h3>
          <div className="space-y-2">
            {questionObj.options.map((option, index) => (
              <div key={index} className="flex items-center">
                <input type="radio" name={`question-${questionObj.question}`} className="mr-2" />
                <span>{option}</span>
              </div>
            ))}
          </div>
        </div>
      );
    } else {
      return (
        <div className='p-4 mb-4 border rounded-lg shadow-sm'>
          <h3 className="font-medium mb-3">{questionObj.question} ({questionObj.marks} marks)</h3>
          <div className="space-y-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="border-b border-gray-300 py-2"></div>
            ))}
          </div>
        </div>
      );
    }
  };

  const getGridCols = () => {
    return paperInfo.questionPerLine === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2';
  };

  return (
    <div className="">
      <ol className={`grid ${getGridCols()} gap-4`}>
        {randomQuestions.map((questionObj, index) => (
          <li key={index} className="list-none">
            {renderQuestion(questionObj)}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default step3;